// extracted by mini-css-extract-plugin
export default {"workRightManual":"workRightManual_workRightManual__ZraXF","workRightManual_countRows":"workRightManual_workRightManual_countRows__IAhkW"};